export default __webpack_public_path__ + "static/media/berny-artworkinfo1.5df7668e.png";